/**
 * Audience attribution module.
 * Captures topic + gender from LP section settings or URL params, stores in
 * sessionStorage (last-touch), and populates hidden form inputs on page load.
 *
 * Priority: LP section data tag > ?bubs_topic/bubs_gender URL params > nothing
 */
(function () {
  var STORAGE_KEY = 'bubs:lp_attribution';

  function capture() {
    // 1. LP section settings (highest priority — marketer-configured)
    var tag = document.getElementById('bubs-lp-attribution-data');
    if (tag) {
      try {
        var data = JSON.parse(tag.textContent);
        if (data.topic || data.gender) {
          return { topic: data.topic || '', gender: data.gender || '', source: 'landing-page' };
        }
      } catch (e) {}
    }

    // 2. URL params — nice-to-have, requires Meta team to append ?bubs_topic=…&bubs_gender=… to ad URLs
    try {
      var params = new URLSearchParams(window.location.search);
      var topic = params.get('bubs_topic') || '';
      var gender = params.get('bubs_gender') || '';
      if (topic || gender) {
        return { topic: topic, gender: gender, source: 'url-param' };
      }
    } catch (e) {}

    return null;
  }

  function syncFormInputs(attribution) {
    var hasData = attribution && (attribution.topic || attribution.gender);
    var fields = [
      { selector: '[data-lp-topic]', key: 'topic' },
      { selector: '[data-lp-gender]', key: 'gender' },
      { selector: '[data-lp-source]', key: 'source' }
    ];
    fields.forEach(function (f) {
      document.querySelectorAll(f.selector).forEach(function (el) {
        if (hasData) {
          el.value = attribution[f.key] || '';
          el.removeAttribute('disabled');
        } else {
          el.setAttribute('disabled', '');
        }
      });
    });
  }

  // Capture fresh signal from this page
  var fresh = capture();
  var stored = null;
  try { stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY)); } catch (e) {}

  // Last-touch: overwrite stored value whenever we have a fresh signal
  var attribution = fresh || stored || null;
  if (fresh) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fresh)); } catch (e) {}
  }

  // Expose globally for Recharge V2 add-to-cart path (no form serialization)
  try {
    Object.defineProperty(window, 'bubsLPAttribution', {
      get: function () { return attribution || {}; },
      configurable: true
    });
  } catch (e) {
    window.bubsLPAttribution = attribution || {};
  }

  // Populate or disable hidden form inputs
  // Scripts loaded with defer run after HTML is parsed, so DOM is ready here
  syncFormInputs(attribution);
})();
